import { render } from "./widget-dop-okved.vue?vue&type=template&id=9f81fe3c"
import script from "./widget-dop-okved.vue?vue&type=script&setup=true&lang=js"
export * from "./widget-dop-okved.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-card/widgets/widget-dop-okved.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9f81fe3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f81fe3c', __exports__)) {
    api.reload('9f81fe3c', __exports__)
  }
  
  module.hot.accept("./widget-dop-okved.vue?vue&type=template&id=9f81fe3c", () => {
    api.rerender('9f81fe3c', render)
  })

}


export default __exports__